import { createGenericApiSlice } from '../../../Api/Factory/genericApiFactory';
import { TagTypes } from '../../../Api/Types/tagTypes';
import {
  ContractTemplate,
  CreateContractTemplateCommand,
  UpdateContractTemplateCommand,
} from '../Types/contractTemplatesTypes';

export const contractTemplatesApi = createGenericApiSlice<
  ContractTemplate,
  CreateContractTemplateCommand, // TCreate
  UpdateContractTemplateCommand, // TUpdate
  number, // TCreateResponse - zwraca ID
  void // TUpdateResponse - zwraca void
>({
  reducerPath: 'contractTemplatesApi',
  tag: TagTypes.ContractTemplate,
  endpoint: 'contract-templates',
});

export const {
  useGetAllQuery: useGetContractTemplatesQuery,
  useGetByIdQuery: useGetContractTemplateByIdQuery,
  useCreateMutation: useCreateContractTemplateMutation,
  useUpdateMutation: useUpdateContractTemplateMutation,
  useDeleteMutation: useDeleteContractTemplateMutation,
} = contractTemplatesApi;
